import React from 'react';

/**
 * Estado vacío estándar: tarjeta blanca con borde, icono y mensaje.
 *
 * Props: icon (componente lucide), title, message, children (p. ej. un CTA).
 */
const EmptyState = ({ icon: Icon, title = 'Nothing to show', message, children }) => (
  <div className="text-center py-12 px-4 bg-surface rounded-xl border border-gray-200">
    {Icon && (
      <div className="mx-auto mb-3 w-11 h-11 rounded-lg bg-gray-100 flex items-center justify-center">
        <Icon className="h-5 w-5 text-gray-500" aria-hidden="true" />
      </div>
    )}
    {title && <p className="text-gray-900 font-medium">{title}</p>}
    {message && <p className="text-sm text-gray-500 mt-1">{message}</p>}
    {children && <div className="mt-4">{children}</div>}
  </div>
);

export default EmptyState;
